import axios from './interceptor'
import { baseUrl } from './config'

export default {
  async scopelogin (params) {
    const res = await axios.post(`${baseUrl}/c/user/scopelogin`, {
      merchantUsername: params.merchantUsername,
      username: params.username,
      password: params.password,
    }, {
      skipAuthorization: true,
    })
    return res.data
  },
  async register (payload, hash, client) {
    const res = await axios.post(`${baseUrl}/c/user/register`, {
      payload,
      hash,
      client,
    }, {
      skipAuthorization: true,
    })
    return res.data
  },

  async refresh (token) {
    const res = await axios.post(`${baseUrl}/c/user/refresh`, {
      token: token,
    }, {
      skipAuthorization: true,
    })
    return res.data
  },

  async createCustomer () {
    const res = await axios.post(`${baseUrl}/customer`)
    return res.data
  },
}



// WEBPACK FOOTER //
// ./src/services/api/user.js